export { AuthService } from './auth.service'; // You have to uncomment this, when your real back-end is done
